import React, { useState } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import AddIcon from '@material-ui/icons/Add'
import {Dialog,Button,FormControl,FormLabel,Select,MenuItem, FormHelperText, InputLabel} from '@material-ui/core'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import IconButton from '@material-ui/core/IconButton'
import PropTypes from 'prop-types'
import Switch from '@material-ui/core/Switch'
import TextField from '@material-ui/core/TextField'
import Tooltip from '@material-ui/core/Tooltip'
import { TiTimes } from 'react-icons/ti';
import { BiArrowFromBottom } from 'react-icons/bi';
import { TagsInput } from '../../General';
import { Builders } from '../..';

const initialQuestion = {
	label: '',
	description: '',
	instructions: '',
	localization: 'US-EN',
	help: '',
	status: 'pending',
	type: '',
  dictionnary: '',
  options: [],
	tag: []
};

const initialOption = {
  goto: 'next',
  label: '',
  value: '',
  order: 0
}

const AddQuestionDialog = (props) => {
	const [ question, setQuestion ] = useState(initialQuestion);
	const { addHandler, open, setOpen } = props;
  const [ newOption, setNewOption ] = useState(initialOption);
  const [ mode, setMode ] = useState('general');

	const [ switchState, setSwitchState ] = React.useState({
		addMultiple: false
	});

	const handleSwitchChange = (name) => (event) => {
		setSwitchState({ ...switchState, [name]: event.target.checked });
	};

	const resetSwitch = () => {
		setSwitchState({ addMultiple: false });
	};

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
		resetSwitch();
	};

	const handleAdd = (event) => {
    var options = [];
    question.options.forEach(option => {
      options.push(JSON.stringify(option));
    });
    const newQuestion = {
      ...question,
      options: options
    }
		addHandler(newQuestion);
		setQuestion(initialQuestion);
		switchState.addMultiple ? setOpen(true) : setOpen(false);
	};

  const validate = () => {
    if (
      question.label
      && question.description
      && question.localization 
      && question.status 
      && question.type
      && question.dictionnary
      && question.options.length > 0
    ) {
      return false;
    } else {
      return true;
    }
  }

  const renderQuestion = () => {
    var options = [];
    question.options.forEach(option => {
      options.push(JSON.stringify(option));
    });
    const _question = {
      ...question,
      options: options
    }
    const qProps = { question: _question };
    return <Builders.Questions.Visualizer {...qProps} dashWidth={5} />
}

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        fullScreen
        className="m-5"
      >
        <DialogTitle id="form-dialog-title">Add Question</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <span onClick={() => setMode('general')} className={mode === 'general' ? "subtitle-toggle subtitle-toggle-selected font-weight-bold" : "subtitle-toggle"}>Edit General Info</span>
              &nbsp;|&nbsp;
            <span onClick={() => setMode('choices')} className={mode === 'choices' ? "subtitle-toggle subtitle-toggle-selected font-weight-bold" : "subtitle-toggle"}>Edit Type and Choices</span>
          </DialogContentText>
          <Row>
            <Col md={9} >
              <Builders.Questions.Main question={question} setQuestion={setQuestion} mode={mode} />
            </Col>
            <Col md={3} className="d-none d-md-block" >
              <div className="iphone-sim">
                  <h5 className="text-center">{question.instructions}</h5>
                  <h5 className="text-center">{question.label}</h5>
                  <div className="live-choice-container">
                    {renderQuestion()}
                  </div>
              </div>
            </Col>
          </Row>
         </DialogContent>
        <DialogActions>
          <Tooltip title="Add multiple">
            <Switch
              checked={switchState.addMultiple}
              onChange={handleSwitchChange('addMultiple')}
              value="addMultiple"
              inputProps={{ 'aria-label': 'secondary checkbox' }}
            />
          </Tooltip>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button disabled={validate()} onClick={handleAdd} color="primary">
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

AddQuestionDialog.propTypes = {
	addHandler: PropTypes.func.isRequired
};

export default AddQuestionDialog;
